import { render, staticRenderFns } from "./ResetPasswordConf.vue?vue&type=template&id=ea38e2dc&scoped=true&"
import script from "./ResetPasswordConf.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordConf.vue?vue&type=script&lang=ts&"
import style0 from "./ResetPasswordConf.vue?vue&type=style&index=0&id=ea38e2dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea38e2dc",
  null
  
)

export default component.exports